import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getDependentRelationshipTypes = info =>
  call(websocketFetch, 'get_dependent_relationship_types', info);
